import cx from "classnames";

import CentralizedModalContainer from "../../Utils/CentralizedModalContainer/CentralizedModalContainer";
import { Button, DialogActions, DialogTitle, Flex, Modal, Text } from "@theorgchartdev/storybook";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { appstr } from "@coreapp/utils/appstr";
import { MainContainer } from "../../Utils/MainContainer";
import { gShowMainNavigation } from "@coreapp/whitelabel/brand";

export const calcContainerSizeStyle = () => {
  return {
    width: gShowMainNavigation ? "calc(100% - 80px)" : "100%", // main nav static 80 px
    zIndex: 1
  };
};

const SettingsModal = ({ dividers, children, title, subtitle, subText, ...props }) => {
  const nav = useAppNavigate();
  // Cancel must always exit Settings to the current chart/plan/file —
  // history-relative navigate(-1) was popping internal tab pushes instead.
  // Forward the canvas-context passengers (mode, tool, view, etc.) that
  // navigateSettings carried in, so the underlying canvas state resumes.
  const closeSettings = () => {
    nav.toCurrentResource(nav.getCanvasContextParams(), { replace: true });
  };

  return (
    <CentralizedModalContainer show={true}>
      <MainContainer className={"ocn-settings-wrapper"} style={calcContainerSizeStyle()}>
        <Modal
          {...props}
          id="example-modal"
          centerScreen={false}
          hideOverlay={true}
          fullWidth={true}
          show={true}
          customStyle={calcContainerSizeStyle()}
          onClose={() => closeSettings()}
          focusTrap={false}
        >
          <DialogTitle customTitleClass={"ocn-settings-title"}>
            <Flex direction="column" alignItems="flex-start" gap={"8px"}>
              <Text
                element={"h1"}
                type={"display"}
                style={{
                  marginBottom: 0,
                  marginBlockStart: 0,
                  marginBlockEnd: 0,
                  fontWeight: "500",
                  fontSize: "36px"
                }}
              >
                {`${title} > ${subtitle}`}
              </Text>
              {subText && (
                <Text element="p" size="small">
                  {subText}
                </Text>
              )}
            </Flex>
          </DialogTitle>
          {children({ onCloseModal: closeSettings })}
        </Modal>
      </MainContainer>
    </CentralizedModalContainer>
  );
};

export const SettingsModalAction = ({
  saveButtonProps,
  cancelButtonProps,
  resetButtonProps,
  refreshButtonProps,
  forceRequeueButtonProps,
  reloadFormulasButtonProps
}) => {
  return (
    <DialogActions customActionsClass={"ocn-settings-footer"} divider={true}>
      <Flex gap={"8px"} justifyContent={"flex-start"}>
        {resetButtonProps && (
          <DialogActions.Danger {...resetButtonProps}>
            {resetButtonProps.label || appstr("Reset")}
          </DialogActions.Danger>
        )}
        {refreshButtonProps && (
          <DialogActions.Secondary {...refreshButtonProps}>
            {refreshButtonProps.label || appstr("Refresh")}
          </DialogActions.Secondary>
        )}
        {forceRequeueButtonProps && (
          <DialogActions.Secondary {...forceRequeueButtonProps}>
            {appstr("Force queue refresh")}
          </DialogActions.Secondary>
        )}
        {reloadFormulasButtonProps && (
          <DialogActions.Secondary size={"large"} {...reloadFormulasButtonProps}>
            {appstr("Force calculate formulas")}
          </DialogActions.Secondary>
        )}
      </Flex>
      <Flex gap={"8px"}>
        {cancelButtonProps && (
          <DialogActions.Tertiary {...cancelButtonProps}>
            {cancelButtonProps.label || appstr("Cancel")}
          </DialogActions.Tertiary>
        )}
        {saveButtonProps && (
          <DialogActions.Primary {...saveButtonProps}>
            {saveButtonProps.label || appstr("Save")}
          </DialogActions.Primary>
        )}
      </Flex>
    </DialogActions>
  );
};

export default SettingsModal;
